<template>
    <span class="oi oi-star mr-1" :class="classes"></span>
</template>

<script>

export default {
    props: {
        rating: {
            type: Object,
            required: true
        }
    },
    computed: {
        classes: function() {
            return {
                "text-amber": this.rating.highlight,
                "text-inactive": !this.rating.highlight,
            }
        }
    }
}
</script>